module.exports = __webpack_public_path__ + "img/a2.619b8ec8.png";